import { Fragment } from 'react';
import ViewToolbarShareButton from './toolbar/ViewToolbarShareButton';
import ViewToolbarDownloadButton from './toolbar/ViewToolbarDownloadButton';
import PublicViewToolbarDownloadButton from './toolbar/PublicViewToolbarDownloadButton';
import ViewSender from './ViewSender';
import { isChirpEnabled } from '../../utils/isChirpEnabled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ViewActions({
  brandingColor,
  presentation,
  sharedLink,
  fetchDownloadLink,
  meetingLink
}) {
  const isUngatedToChirp = isChirpEnabled();
  const user = isUngatedToChirp ? sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.user : presentation === null || presentation === void 0 ? void 0 : presentation.user;
  const shortLink = isUngatedToChirp ? sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.shortLink : presentation === null || presentation === void 0 ? void 0 : presentation.shortLink;
  const isPublicContext = Boolean((presentation === null || presentation === void 0 ? void 0 : presentation.accessId) || (sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.accessId));
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ViewToolbarShareButton, {
      brandingColor: brandingColor,
      shortLink: shortLink
    }), isPublicContext ? /*#__PURE__*/_jsx(PublicViewToolbarDownloadButton, {
      brandingColor: brandingColor,
      presentation: presentation,
      sharedLink: sharedLink,
      fetchDownloadLink: fetchDownloadLink
    }) : /*#__PURE__*/_jsx(ViewToolbarDownloadButton, {
      brandingColor: brandingColor,
      presentation: presentation,
      sharedLink: sharedLink,
      fetchDownloadLink: fetchDownloadLink
    }), /*#__PURE__*/_jsx(ViewSender, {
      user: user,
      meetingLink: meetingLink,
      brandingColor: brandingColor
    })]
  });
}
export default ViewActions;